import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import MemberDetails from '@/components/MemberDetails'
import MemberList from '@/components/MemberList'
import MembersWithBelt from '@/components/MembersWithBelt'
import Countries from '@/components/Countries'
import Country from '@/components/Country'
import Dojos from '@/components/Dojos'
import Dojo from '@/components/Dojo'
import Belts from '@/components/Belts'
import Events from '@/components/Events'
import About from '@/components/About'
import Rankings from '@/components/Rankings'
import Results from '@/components/Results'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/start',
      alias: '/',
      name: 'Start',
      component: Hello
    },
    {
      path: '/member/:map',
      name: 'MemberDetails',
      component: MemberDetails
    },
    {
      path: '/memberlist',
      name: 'MemberList',
      component: MemberList
    },
    {
      path: '/countries',
      name: 'Countries',
      component: Countries
    },
    {
      path: '/country/:id/',
      name: 'Country',
      component: Country
    },
    {
      path: '/belts/:id/members',
      name: 'BeltMembers',
      component: MembersWithBelt
    },
    {
      path: '/dojos',
      name: 'Dojos',
      component: Dojos
    },
    {
      path: '/dojo/:id',
      name: 'Dojo',
      component: Dojo
    },
    {
      path: '/belts',
      name: 'Belts',
      component: Belts
    },
    {
      path: '/events',
      name: 'Events',
      component: Events
    },
    {
      path: '/rankings',
      name: 'Rankings',
      component: Rankings
    },
    {
      path: '/results',
      name: 'Results',
      component: Results
    },
    {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})
